import cn from 'classnames';
import React from 'react';

export const BodyCell = ({children, className, bodyCellClassName, withMenu, href, target = null, ...props}) => (
    <td
        className={cn(
            'text-eerie text-12 leading-[20px] px-4 !py-0 h-[45px]',
            {'last:!p-0': withMenu},
            className,
            bodyCellClassName
        )}
        {...props}
    >
        {href ? (
            <a href={href} target={target} rel='noopener noreferrer' className='w-full h-full flex items-center'>
                {children}
            </a>
        ) : (
            children
        )}
    </td>
);

export const BodyRow = ({children, className, ...props}) => (
    <tr
        className={cn(
            'border-b border-divider last:border-b-0 hover:bg-wild-sand transition-colors duration-150',
            className
        )}
        {...props}
    >
        {children}
    </tr>
);

export const HeaderCell = ({children, className, headerCellClassName, ...props}) => (
    <th
        className={cn(
            className,
            '!bg-ghost border-b border-divider !text-nero !font-semibold !text-12 leading-[20px] !h-[45px] !py-0 px-4',
            headerCellClassName
        )}
        {...props}
    >
        {children}
    </th>
);

export const TableWrapper = ({children, ...props}) => (
    <div className='bg-white rounded-[8px] shadow-table overflow-hidden'>
        <table className='w-full' {...props}>
            {children}
        </table>
    </div>
);
